import type { UseQueryResult, QueryClient } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { UserPermissions, AppName } from '../types';

export interface UsePermissionQueryOptions {
  appName: AppName;
  fetchPermissions: () => Promise<unknown>;
  refetchInterval?: number;
  refetchOnWindowFocus?: boolean;
}

export function usePermissionQuery(
  options: UsePermissionQueryOptions,
): UseQueryResult<UserPermissions> {
  const {
    appName, fetchPermissions, refetchInterval = 5 * 60 * 1000, refetchOnWindowFocus = true,
  } = options;

  return useQuery({
    queryKey: ['permissions', appName],
    queryFn: async () => {
      const apiPermissions = await fetchPermissions();
      return apiPermissions as UserPermissions;
    },
    refetchInterval,
    refetchOnWindowFocus,
    staleTime: 1000 * 60,
    gcTime: 1000 * 60 * 60 * 24,
  });
}

export function invalidatePermissions(queryClient: QueryClient, appName: AppName): void {
  queryClient.invalidateQueries({ queryKey: ['permissions', appName] });
}
